import { styled } from '@mui/material';

/** Older bars fade out under a 48px mask on the left edge. */
export const History = styled('span')({
  maskImage: 'linear-gradient(to right, transparent, black 48px)',
});

/**
 * Each new bar grows in where it enters, on the right. Full colour from the first frame, and done within one
 * 70ms tick: a fade that outlasted the tick kept the newest bars part-transparent, so the bar by the buttons
 * looked pale and blinked as each new one restarted it.
 */
export const BarIn = styled('span')({
  '@keyframes formsWaveformBarIn': {
    from: { transform: 'scale(0.6)' },
    to: { transform: 'none' },
  },
  animation: 'formsWaveformBarIn 60ms var(--ease-entrance) both',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
});
